import { Colors } from 'basic-ui-lib';
import { LayoutCode } from 'modules/channel/services/constants';

export const NAME_REDUCER = 'dashboard';

export const PREFIX_ACTIONS = 'dashboard_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};

export enum ScreenStatus {
    NEW= 'NEW',
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
    DELETED = 'DELETED',
    DEACTIVATED = 'DEACTIVATED',
    SUSPENDED = 'SUSPENDED',
    DRAFT = 'DRAFT'
}

export const StatusOptions = [
  { label: 'All Status', value: '' },
  { label: 'Online', value: ScreenStatus.ONLINE },
  { label: 'Offline', value: ScreenStatus.OFFLINE },
  { label: 'Deactivated', value: ScreenStatus.DEACTIVATED },
  { label: 'Draft', value: ScreenStatus.DRAFT }
];

export interface LayoutMetadata {
  layoutCode: LayoutCode;
  name: string;
  zones: string[];
}

export const StatusScreenConfigs = {
  [ScreenStatus.NEW]: {
    label: 'New',
    backgroundColor: Colors.secondary[4],
    color: '#FFFFFF',
  },
  [ScreenStatus.ONLINE]: {
    label: 'Online',
    backgroundColor: Colors.secondary[5],
    color: '#FFFFFF',
  },
  [ScreenStatus.DEACTIVATED]: {
    label: 'Deactivated',
    backgroundColor: Colors.orange[2],
    color: '#FFFFFF',
  },
  [ScreenStatus.DRAFT]: {
    label: 'Draft',
    backgroundColor: Colors.primary[5],
    color: '#FFFFFF',
  },
  [ScreenStatus.OFFLINE]: {
    label: 'Offline',
    backgroundColor: Colors.neutral.bg[3],
    color: '#000000',
  },
  [ScreenStatus.SUSPENDED]: {
    label: 'Suspended',
    backgroundColor: Colors.other[3],
    color: '#FFFFFF',
  },
  [ScreenStatus.DELETED]: {
    label: 'Deleted',
    backgroundColor: Colors.other[3],
    color: '#FFFFFF',
  },
};
